import axios from "axios";

export class HardwareCatalogClient {
    baseUrl;

    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

     getAll(entityType, columnFiltersQuery, globalFilter, sortQuery, pageNumber, pageSize) {
        return axios.get(`${this.baseUrl}/${entityType}`,
            {
                params: {
                    searchQuery: columnFiltersQuery,
                    sortQuery: sortQuery,
                    page: pageNumber,
                    size: pageSize
                }
            });
    }

    getById(entityId) {
        return axios.get(`${this.baseUrl}/${entityId}`)
            .then(response => response.data)
            .catch(error => {
                return null;
            });
    }

    create(entityType, entity) {
        return axios.post(`${this.baseUrl}/${entityType}`, entity)
    }

     update(entityType, entity) {
        return axios.put(`${this.baseUrl}/${entityType}`, entity)
    }

     remove(entityType, entityId) {
        return axios.delete(`${this.baseUrl}/${entityType}/${entityId}`)

    }

    getAllEnums() {
        return axios.get(`${this.baseUrl}/enums-list`)
            .then(response => response)
            .catch(error => {
                return null;
            });
    }
}
